import { render, staticRenderFns } from "./Rbcz.vue?vue&type=template&id=77de37e3&"
import script from "./Rbcz.vue?vue&type=script&lang=js&"
export * from "./Rbcz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports